import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";

import { db } from "../../../firebase";
import { ResultPages, ResultPageConfig } from "../../../types/ResultPageData";
import Results from "../Results/ResultScore";

// URLのid（例: QF2026xxxxxxxx）の3〜6文字目に4桁の年が埋め込まれている
const getYearFromId = (id: string): number | null => {
  if (!id || id.length < 7) return null;

  const yearString = id.slice(2, 6);
  const year = Number(yearString);

  return /^\d{4}$/.test(yearString) && !Number.isNaN(year) ? year : null;
};

export default function PublicResultPage() {
  const { id } = useParams<{ id: string }>();

  const [year, setYear] = useState<number | null>(null);
  const [finalistCount, setFinalistCount] = useState<number | null>(null);
  const [pageConfig, setPageConfig] = useState<ResultPageConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const parsedYear = id ? getYearFromId(id) : null;

    if (!id || parsedYear === null) {
      setYear(null);
      setPageConfig(null);
      setFinalistCount(null);
      setLoading(false);
      return;
    }

    setYear(parsedYear);

    // resultPagesコレクション全件ではなく、URLから分かる年のドキュメント1件だけを購読する
    // （このページは閲覧数が多いため、読み取り件数の削減を優先している）
    const unsubscribe = onSnapshot(
      doc(db, "resultPages", String(parsedYear)),
      (snapshot) => {
        if (!snapshot.exists()) {
          setPageConfig(null);
          setFinalistCount(null);
          setLoading(false);
          return;
        }

        const data = snapshot.data() as ResultPages;
        const pages = Object.values(data.pages || {}) as ResultPageConfig[];
        const foundPage = pages.find((page) => page.id === id) ?? null;

        setPageConfig(foundPage);
        setFinalistCount(data.finalistCount ?? null);
        setLoading(false);
      },
      (error) => {
        console.error("リザルトページ取得エラー:", error);
        setPageConfig(null);
        setFinalistCount(null);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [id]);

  if (loading) {
    return <div>読み込み中...</div>;
  }

  // ページが存在しない
  if (!pageConfig || year === null) {
    return <div>ページが見つかりません</div>;
  }

  // 非公開
  if (!pageConfig.published) {
    return <div>このページは現在公開されていません。</div>;
  }

  // 公開中
  return (
    <Results year={year} pageConfig={pageConfig} finalistCount={finalistCount} />
  );
}
